/**
 * Modern Primary Button Component
 * Replaces the old primary-pink-button with modern design system
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from './ui/Button';

const PrimaryButton = ({
  button,
  action,
  loading = false,
  disabled = false,
  leftIcon,
  rightIcon,
  size = 'md',
  ...props
}) => {
  return (
    <Button
      variant="primary"
      size={size}
      onClick={action}
      loading={loading}
      disabled={disabled}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      {...props}
    >
      {button}
    </Button>
  );
};

PrimaryButton.propTypes = {
  button: PropTypes.string.isRequired,
  action: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

export default PrimaryButton;
